import { FieldPath } from 'react-hook-form';
import { EnumMasterSort } from 'view/Layout/enum';
import { EnumMaster, QueryOrderForm } from './init';

export const nameMaster = (
  field: FieldPath<typeof EnumMaster>,
): FieldPath<QueryOrderForm> => `master.${field}`;

export const masterName: FieldPath<QueryOrderForm> = 'master';

export const nameMasterSort = (
  field: EnumMasterSort,
  rowIdx: number,
): FieldPath<QueryOrderForm> => `masterSort.${rowIdx}.${field}`;

/** 排序選項 */
export const propertyOption = [
  { label: '未排序', value: '' },
  { label: '訂單號碼', value: 'orderNo' },
  { label: '訂單日期', value: 'orderDate' },
  {
    label: '到貨日期',
    value: 'deliverEndDate',
  },
  { label: '異動日期', value: 'updDate' },
  {
    label: '分店/倉庫代碼',
    value: 'buyerGLN',
  },
];
